import "@fontsource/open-sans"
import "./src/theme/animate.min.css"
import "./src/theme/index.scss"
import "./src/theme/style.css"